// bao migrate skip
import "./../interfaces/ipage";
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-tabs";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import TabController from "./../factories/tab-controller";
import tabPage from "./../factories/tab-page";
import BaoDialog from "./../factories/bao-dialog";
import Bao from "./../services/bao-service";
import * as ko from "knockout";
class BillingExport {
    TabPage: tabPage;
    Sorting = ko.observableArray<{
        Column: string;
        Direction: string;
    }>([]);
    BillingFolderId = ko.observable("");
    BillingFolderItem = ko.observable();
    Billings = ko.observableArray([]);
    BillingExportTypes = ko.observableArray([]);
    SelectedBillingExportType = ko.observable();
    UserEmailAdress = ko.observable();
    NoZeroValues = ko.observable(false);
    NoBillingfolderMessage = ko.observable("");
    NoBillingsSelectedMessage = ko.observable("");
    BaoSearcherBinding = {
        ObjectId: this.BillingFolderId,
        ObjectValue: 'Name',
        SearchType: 'BillingFolder',
        AutoComplete: false,
        AutoSearch: true,
        SelectedItem: this.BillingFolderItem
    };
    constructor(tabPage: TabPage) {
        this.TabPage = tabPage;
        this.BillingFolderId.subscribe(() => {
            this.GetBillings();
        });
    }
    loaded() {
        this.Sorting.subscribe((sortings) => {
            this.Billings.sort((l, r) => {
                for (let i in sortings) {
                    let sorting = sortings[i];
                    if (l[sorting.Column] === null || l[sorting.Column] < r[sorting.Column]) {
                        return (sorting.Direction === "Ascending" ? -1 : 1);
                    }
                    else if (l[sorting.Column] > r[sorting.Column] || r[sorting.Column] === null) {
                        return (sorting.Direction === "Ascending" ? 1 : -1);
                        // equal, check next sort level if available
                    }
                    else {
                    }
                }
                // if all sort levels were equal, the items are equal -> return 0
                return 0;
            });
        });
        this.TabPage.IsLoading(false);
    }
    init() {
        this.TabPage.IsLoading(true);
        return $.when(this.GetExportTypes(), this.GetUserEmail(), Bao.Session.GetCaptions("BillingExport", Bao.Session.Language.Symbol).then((captions) => {
            this.TabPage.Title(captions.TabTitle);
            this.NoBillingfolderMessage(captions.msgNoBillingFolderSelected);
            this.NoBillingsSelectedMessage(captions.msgNoBillingsSelected);
        }));
    }
    GetBillings() {
        this.TabPage.IsLoading(true);
        Bao.post("BillingExport/GetBillings", JSON.stringify({
            billingFolderId: this.BillingFolderId()
        }), (result) => {
            this.Billings(result.Billings.map(item => {
                item.SelectedForExport = false;
                return item;
            }));
            this.TabPage.IsLoading(false);
        });
    }
    GetExportTypes() {
        Bao.post("BillingExport/GetExportTypes", (result) => {
            this.BillingExportTypes(result.BillingExportTypes);
        });
    }
    GetUserEmail() {
        Bao.post("BillingExport/GetUserEmail", (result) => {
            this.UserEmailAdress(result.UserEmailAdress);
        });
    }
    GetBillingsForExport() {
        return this.Billings().filter(x => x.SelectedForExport);
    }
    ExportBilling() {
        if (Bao.Utils.String.IsNullOrWhitespace(this.BillingFolderId())) {
            let errorDialog = new BaoDialog(Bao.Session.ApplicationName, this.NoBillingfolderMessage, "info");
            return;
        }
        if (this.GetBillingsForExport().length == 0) {
            let errorDialog = new BaoDialog(Bao.Session.ApplicationName, this.NoBillingsSelectedMessage, "info");
            return;
        }
        this.TabPage.IsLoading(true);
        Bao.post("BillingExport/ExportBilling", JSON.stringify({
            billingFolderId: this.BillingFolderId(),
            billings: this.GetBillingsForExport(),
            exportType: this.SelectedBillingExportType(),
            emailAdress: this.UserEmailAdress(),
            noZeroValues: this.NoZeroValues()
        }), (result) => {
            let dialog = new BaoDialog(Bao.Session.ApplicationName, result.message, "info");
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
}
export default BillingExport;